





// // ------------ version 3 --------------
// import React from "react";
// import CvInfo from "./CvInfo";
// import CvEducation from "./CvEducation";
// import CvWorkExperience from "./CvWorkExperience";
// import CvCertificate from "./CvCertificate";
// import CvGuarantor from "./CvGuarantor";
// import { useSelector } from "react-redux";
// import PDFGenerator from "./pdf/PDFGenerator";
// import { FaCalendar, FaCheck } from 'react-icons/fa';

// function CvTemplate2({ education, experience, certificate, guarantor }) {
//   const loggedInUser = useSelector(state => state.user);
//   const currentDate = new Date().toLocaleDateString('en-GB');

//   return (
//     <PDFGenerator>
//       <div className="bg-gradient-to-br from-gray-900 to-black text-white min-h-[297mm] w-full max-w-[210mm] mx-auto overflow-hidden">
        
//         {/* Header Section */}
//         <div className="bg-gradient-to-r from-gray-800 to-gray-900 p-6 sm:p-8">
//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
//             <div>
//               <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
//                 <h1 className="text-2xl font-bold">e-Job CV</h1>
//                 <button className="px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors flex items-center gap-2 text-sm whitespace-nowrap">
//                   <FaCheck className="text-green-400" />
//                   e-verify log
//                 </button>
//               </div>
//               <p className="mt-2 text-gray-400 text-sm">Verify and certify the best to the world</p>
//             </div>
//             <div className="text-left sm:text-right">
//               <p className="text-gray-400 font-medium text-sm">Date Generated</p>
//               <div className="flex items-center gap-2 text-gray-300">
//                 <FaCalendar className="text-gray-500" />
//                 <span>{currentDate}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Personal Info Section */}
//         <div className="px-6 sm:px-8 py-10 sm:py-12 border-l-4 border-gray-700 ml-6 sm:ml-8">
//           <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-100 leading-tight">
//             {`${loggedInUser.currentUser.firstName} ${loggedInUser.currentUser.lastName}`}
//           </h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-gray-300">
//             <CvInfo title="Date of Birth" data={loggedInUser.currentUser.dateOfBirth} />
//             <CvInfo title="Email" data={loggedInUser.currentUser.email} />
//             <CvInfo title="Address" data={loggedInUser.currentUser.address} />
//           </div>
//         </div>

//         {/* Main Content Section */}
//         <div className="bg-white text-gray-800 rounded-tl-[3rem] sm:rounded-tl-[4rem] px-6 sm:px-8 py-10 sm:py-12">
          
//           {/* Education Section */}
//           <div className="mb-12">
//             <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
//               Education Background
//             </h3>
//             <div className="space-y-6">
//               {education?.map((eachEducation, index) => (
//                 <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
//                   <CvEducation
//                     school={eachEducation?.school}
//                     course={eachEducation?.course}
//                     year={`${eachEducation?.startYear} ${eachEducation?.finishYear}`}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Work Experience Section */}
//           <div className="mb-12">
//             <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
//               Work Experience
//             </h3>
//             <div className="space-y-6">
//               {experience?.map((eachExperience, index) => (
//                 <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
//                   <CvWorkExperience
//                     title={eachExperience?.positionHeld}
//                     companyName={eachExperience?.companyName}
//                     year={`${eachExperience?.startYear} - ${eachExperience?.finishYear}`}
//                     jobDescription={eachExperience?.jobDescription}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Certificates Section */}
//           <div className="mb-12">
//             <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
//               Certificates
//             </h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//               {certificate?.map((eachCertificate, index) => (
//                 <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
//                   <CvCertificate
//                     title={eachCertificate?.certificateName}
//                     year={eachCertificate?.issueDate}
//                     serialNumber={eachCertificate?.serialNumber}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Guarantor Section */}
//           <div>
//             <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
//               Guarantor
//             </h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//               {guarantor.map((eachGuarantor, index) => (
//                 <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
//                   <CvGuarantor
//                     guarantorName={eachGuarantor.name}
//                     phoneNumber={eachGuarantor.phone}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </PDFGenerator>
//   );
// }

// export default CvTemplate2;








// ------------ version 3 - Editable --------------
import React, { useState, useEffect } from "react";
import CvInfo from "./CvInfo";
import CvEducation from "./CvEducation";
import CvWorkExperience from "./CvWorkExperience";
import CvCertificate from "./CvCertificate";
import CvGuarantor from "./CvGuarantor";
import { useSelector } from "react-redux";
import PDFGenerator from "./pdf/PDFGenerator";
import { FaCalendar, FaCheck, FaEdit, FaSave } from 'react-icons/fa';

function CvTemplate2({ education, experience, certificate, guarantor }) {
  const loggedInUser = useSelector(state => state.user);
  const currentDate = new Date().toLocaleDateString('en-GB');

  // Local state for editing
  const [isEditing, setIsEditing] = useState(false);
  const [editableData, setEditableData] = useState({
    personalInfo: {
      firstName: loggedInUser?.currentUser?.firstName || '',
      lastName: loggedInUser?.currentUser?.lastName || '',
      dateOfBirth: loggedInUser?.currentUser?.dateOfBirth || '',
      email: loggedInUser?.currentUser?.email || '',
      address: loggedInUser?.currentUser?.address || '',
    },
    education: education || [],
    experience: experience || [],
    certificate: certificate || [],
    guarantor: guarantor || [],
  });

  // Sync props with local state when they change
  useEffect(() => {
    setEditableData({
      personalInfo: {
        firstName: loggedInUser?.currentUser?.firstName || '',
        lastName: loggedInUser?.currentUser?.lastName || '',
        dateOfBirth: loggedInUser?.currentUser?.dateOfBirth || '',
        email: loggedInUser?.currentUser?.email || '',
        address: loggedInUser?.currentUser?.address || '',
      },
      education: education || [],
      experience: experience || [],
      certificate: certificate || [],
      guarantor: guarantor || [],
    });
  }, [loggedInUser, education, experience, certificate, guarantor]);

  // Handle personal info changes
  const handlePersonalChange = (field, value) => {
    setEditableData(prev => ({
      ...prev,
      personalInfo: {
        ...prev.personalInfo,
        [field]: value
      }
    }));
  };

  // Handle changes in array sections
  const handleArrayChange = (section, index, field, value) => {
    setEditableData(prev => {
      const newArray = [...prev[section]];
      newArray[index] = { ...newArray[index], [field]: value };
      return { ...prev, [section]: newArray };
    });
  };

  const toggleEdit = () => {
    if (isEditing) {
      console.log("CV Changes Saved:", editableData);
      // You can dispatch to Redux here later
    }
    setIsEditing(!isEditing);
  };

  return (
    <PDFGenerator>
      <div className="bg-gradient-to-br from-gray-900 to-black text-white min-h-[297mm] w-full max-w-[210mm] mx-auto overflow-hidden relative">

        {/* Floating Edit/Save Button */}
        <button
          onClick={toggleEdit}
          className="absolute top-6 right-6 z-30 px-5 py-2.5 rounded-xl bg-gray-700 hover:bg-gray-600 text-white flex items-center gap-2 text-sm font-medium transition-all shadow-lg"
        >
          {isEditing ? (
            <>
              <FaSave className="text-lg" /> Save Changes
            </>
          ) : (
            <>
              <FaEdit className="text-lg" /> Edit CV
            </>
          )}
        </button>

        {/* Header Section */}
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 p-6 sm:p-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                <h1 className="text-2xl font-bold">e-Job CV</h1>
                {/* <button className="px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors flex items-center gap-2 text-sm whitespace-nowrap">
                  <FaCheck className="text-green-400" />
                  e-verify log
                </button> */}
              </div>
              {/* <p className="mt-2 text-gray-400 text-sm">Verify and certify the best to the world</p> */}
            </div>
            <div className="text-left sm:text-right">
              <p className="text-gray-400 font-medium text-sm">Date Generated</p>
              <div className="flex items-center gap-2 text-gray-300">
                <FaCalendar className="text-gray-500" />
                <span>{currentDate}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Personal Info Section */}
        <div className="px-6 sm:px-8 py-10 sm:py-12 border-l-4 border-gray-700 ml-6 sm:ml-8">
          <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-100 leading-tight">
            {isEditing ? (
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="text"
                  value={editableData.personalInfo.firstName}
                  onChange={(e) => handlePersonalChange('firstName', e.target.value)}
                  className="bg-transparent border-b-2 border-gray-600 focus:border-white outline-none text-2xl sm:text-3xl font-bold w-full"
                  placeholder="First Name"
                />
                <input
                  type="text"
                  value={editableData.personalInfo.lastName}
                  onChange={(e) => handlePersonalChange('lastName', e.target.value)}
                  className="bg-transparent border-b-2 border-gray-600 focus:border-white outline-none text-2xl sm:text-3xl font-bold w-full"
                  placeholder="Last Name"
                />
              </div>
            ) : (
              `${editableData.personalInfo.firstName} ${editableData.personalInfo.lastName}`
            )}
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-gray-300">
            <CvInfo 
              title="Date of Birth" 
              data={isEditing ? (
                <input
                  type="text"
                  value={editableData.personalInfo.dateOfBirth}
                  onChange={(e) => handlePersonalChange('dateOfBirth', e.target.value)}
                  className="bg-transparent border-b border-gray-600 focus:border-white outline-none w-full py-1"
                />
              ) : editableData.personalInfo.dateOfBirth}
            />
            <CvInfo 
              title="Email" 
              data={isEditing ? (
                <input
                  type="email"
                  value={editableData.personalInfo.email}
                  onChange={(e) => handlePersonalChange('email', e.target.value)}
                  className="bg-transparent border-b border-gray-600 focus:border-white outline-none w-full py-1"
                />
              ) : editableData.personalInfo.email}
            />
            <CvInfo 
              title="Address" 
              data={isEditing ? (
                <input
                  type="text"
                  value={editableData.personalInfo.address}
                  onChange={(e) => handlePersonalChange('address', e.target.value)}
                  className="bg-transparent border-b border-gray-600 focus:border-white outline-none w-full py-1"
                />
              ) : editableData.personalInfo.address}
            />
          </div>
        </div>

        {/* Main Content Section */}
        <div className="bg-white text-gray-800 rounded-tl-[3rem] sm:rounded-tl-[4rem] px-6 sm:px-8 py-10 sm:py-12">
          
          {/* Education Section */}
          <div className="mb-12">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
              Education Background
            </h3>
            <div className="space-y-6">
              {editableData.education.map((eachEducation, index) => (
                <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
                  <CvEducation
                    school={isEditing ? (
                      <input
                        type="text"
                        value={eachEducation.school || ''}
                        onChange={(e) => handleArrayChange('education', index, 'school', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachEducation.school}
                    course={isEditing ? (
                      <input
                        type="text"
                        value={eachEducation.course || ''}
                        onChange={(e) => handleArrayChange('education', index, 'course', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachEducation.course}
                    year={isEditing ? (
                      <input
                        type="text"
                        value={`${eachEducation.startYear || ''} ${eachEducation.finishYear || ''}`}
                        onChange={(e) => {
                          const [start, finish] = e.target.value.split(' ').map(s => s.trim());
                          handleArrayChange('education', index, 'startYear', start || '');
                          handleArrayChange('education', index, 'finishYear', finish || '');
                        }}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : `${eachEducation.startYear} ${eachEducation.finishYear}`}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Work Experience Section */}
          <div className="mb-12">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
              Work Experience
            </h3>
            <div className="space-y-6">
              {editableData.experience.map((eachExperience, index) => (
                <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
                  <CvWorkExperience
                    title={isEditing ? (
                      <input
                        type="text"
                        value={eachExperience.positionHeld || ''}
                        onChange={(e) => handleArrayChange('experience', index, 'positionHeld', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachExperience.positionHeld}
                    companyName={isEditing ? (
                      <input
                        type="text"
                        value={eachExperience.companyName || ''}
                        onChange={(e) => handleArrayChange('experience', index, 'companyName', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachExperience.companyName}
                    year={isEditing ? (
                      <input
                        type="text"
                        value={`${eachExperience.startYear || ''} - ${eachExperience.finishYear || ''}`}
                        onChange={(e) => {
                          const parts = e.target.value.split('-').map(p => p.trim());
                          handleArrayChange('experience', index, 'startYear', parts[0] || '');
                          handleArrayChange('experience', index, 'finishYear', parts[1] || '');
                        }}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : `${eachExperience.startYear} - ${eachExperience.finishYear}`}
                    jobDescription={isEditing ? (
                      <textarea
                        value={eachExperience.jobDescription || ''}
                        onChange={(e) => handleArrayChange('experience', index, 'jobDescription', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:border-gray-500 min-h-[90px] resize-y"
                      />
                    ) : eachExperience.jobDescription}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Certificates Section */}
          <div className="mb-12">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
              Certificates
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {editableData.certificate.map((eachCertificate, index) => (
                <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
                  <CvCertificate
                    title={isEditing ? (
                      <input
                        type="text"
                        value={eachCertificate.certificateName || ''}
                        onChange={(e) => handleArrayChange('certificate', index, 'certificateName', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachCertificate.certificateName}
                    year={isEditing ? (
                      <input
                        type="text"
                        value={eachCertificate.issueDate || ''}
                        onChange={(e) => handleArrayChange('certificate', index, 'issueDate', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachCertificate.issueDate}
                    serialNumber={isEditing ? (
                      <input
                        type="text"
                        value={eachCertificate.serialNumber || ''}
                        onChange={(e) => handleArrayChange('certificate', index, 'serialNumber', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachCertificate.serialNumber}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Guarantor Section */}
          <div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 border-b-2 border-gray-200 pb-2">
              Guarantor
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {editableData.guarantor.map((eachGuarantor, index) => (
                <div key={index} className="bg-gray-50 p-5 sm:p-6 rounded-lg">
                  <CvGuarantor
                    guarantorName={isEditing ? (
                      <input
                        type="text"
                        value={eachGuarantor.name || ''}
                        onChange={(e) => handleArrayChange('guarantor', index, 'name', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachGuarantor.name}
                    phoneNumber={isEditing ? (
                      <input
                        type="text"
                        value={eachGuarantor.phone || ''}
                        onChange={(e) => handleArrayChange('guarantor', index, 'phone', e.target.value)}
                        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-gray-500"
                      />
                    ) : eachGuarantor.phone}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PDFGenerator>
  );
}

export default CvTemplate2;